import { Flex } from '@/components';
import { Spin } from 'antd';
import type { FC } from 'react';

type Props = {
  height?: string;
};

export const Loading: FC<Props> = ({ height = '100%' }) => {
  return (
    <Flex style={{ height }} align="center" justify="center">
      <Spin size="large" /> {/* use tip when Spin has children */}
    </Flex>
  );
};
